import { render, staticRenderFns } from "./ModifyPhone.vue?vue&type=template&id=4d67332d&scoped=true"
import script from "./ModifyPhone.vue?vue&type=script&lang=js"
export * from "./ModifyPhone.vue?vue&type=script&lang=js"
import style0 from "./ModifyPhone.vue?vue&type=style&index=0&id=4d67332d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d67332d",
  null
  
)

export default component.exports